<template>
    <main role="main">
        <article class="layout-contents-container">
            <div class="layout-contents" data-dashboard>

                <!-- 검색 필터 -->
                <fieldset class="tbl-filters" :key="getLocale">
                    <legend>table filters</legend>
                    <CVendorSelect
                        style="width: 141px;"
                        :placeholder="$t('FILTER.ACCOUNT')"
                        :options="acntList"
                        :callOnSelect="onChangeAccount"
                    />
                    <div class="actions">
                        <button type="button" class="buttons" data-type="ghost" data-icon="refresh" v-on:click="refresh"><time datetime="">{{ $t('DASHBOARD.LAST_UPDATED')}}<!--마지막 업데이트:--> {{curDate}}</time></button>
                        <!--                        <button type="button" class="buttons" data-type="line" data-icon="download" v-on:click="downloadReport()" >{{ $t('COMMON.REPORT.BUTTON.DOWNLOAD_REPORT')}}&lt;!&ndash;리포트 다운로드&ndash;&gt;</button>-->
                        <!--<button v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" type="button" class="buttons" data-type="line" data-icon="upload" v-on:click="sendReport" >{{ $t('COMMON.REPORT.BUTTON.EXPORT_REPORT')}}&lt;!&ndash;리포트 보내기&ndash;&gt;</button>-->
                    </div>
                </fieldset>
                <!-- 검사 요약 -->
                <dashboard-summary
                    ref="dashboardSummary"
                    v-bind:filter="filterData"
                />

                <div class="dashboard-box-hstack no-flex">
                    <DashboardState
                        :filterData="filterData"
                        :selectedAccounts="filterData.acnt"
                        :accountList="acntList"
                        :locale="getLocale"
                        :curCmpnId="curCmpnId"
                        :failedRulesList="failedRulesList"
                        :pending="pendingState"
                        :inUseVendors="inUseVendors"
                    />
                    <DashboardRegion
                        ref="dashboardRegion"
                        :filter="filterData"
                        :accountList="acntList"
                        :selectedAccounts="filterData.acnt"
                        :inUseVendors="inUseVendors"
                    />
                </div>

                <div class="dashboard-box-hstack no-flex">
                    <dashboard-trend ref="dashboardTrend" v-bind:filter="filterData"></dashboard-trend>
                    <dashboard-fail-rule ref="dashboardFail" v-bind:filter="filterData"></dashboard-fail-rule>
                </div>
            </div>

            <div ref="toastAction" class="toast-popup-ui add" hidden>
                <p>{{ $t('DASHBOARD.COMMING_SOON') }}</p>
                <button class="close" name="button" type="button"></button>
            </div>

            <pop-send-report ref="popSendReport"></pop-send-report>
        </article>

    </main>
</template>

<script>

import DashboardFailRule from "./dashboardFailRule.vue";
import DashboardRegion from "./dashboardRegion.vue";
import DashboardState from "./dashboardState.vue";
import DashboardSummary from "./dashboardSummary.vue";
import DashboardTrend from "./dashboardTrend.vue";
import PopSendReport from "./../common/popSendReport.vue";
import CVendorSelect from "./../common/OptionSelect/CVendorSelect.vue"
import _ from "lodash";
import {mapGetters} from "vuex";

export default {
    name: 'Dashboard',
    components: {
        CVendorSelect,
        DashboardFailRule,
        DashboardRegion,
        DashboardState,
        DashboardSummary,
        DashboardTrend,
        PopSendReport
    },
    data: function () {
        return {
            filterData: {},
            /* filter model*/
            ctgList: [],
            prodList: [],
            acntList: [],
            rgnList: [],

            searchCtg: [],
            searchProd: [],
            searchAcnt: [],
            searchRgn: [],
            curDate: this.getCurrentDate(),
            failedRulesList: [],
            pendingState: false,
            inUseVendors: [],
        }
    },
    created: function () {
        this.getFilterData();
        this.getVendorData();
        this.debouncedSlctFailedRules = _.debounce(this.selectFailedRuleList, 1000);
        this.$store.dispatch('sse/completeSseEventSource');
    },
    mounted: function () {
        $('body').addClass('dashboard');
        document.getElementsByClassName("selection dropdown multiple")[0].addEventListener("click", this.clickOnSelection);
    },
    destroyed: function () {
        $('body').removeClass('dashboard');
    },
    watch: {
        curCmpnId: function () {
            this.getVendorData();
            this.getFilterData();
        }
    },
    computed: {
        ...mapGetters({
            curCmpnId: 'user/curCmpnId'
        }),
        getLocale: function () {
            return this.$i18n.locale
        },
        getMenuAuth: function () {
            //메뉴 별 권한
            let auth = _.find(this.$store.state.GOV_MENU_AUTH, {menuId: this.constants.MENU.DASHBOARD})
            return auth ? auth.authTypeCd : this.constants.AUTH_TYPE.NONE
        }
    },
    methods: {
        onChangeAccount(data) {
            this.changeFilterData('acnt', data);
        },
        clickOnSelection(e) {
            const firstChildNode = _.get(e, "target.firstChild.nodeName");
            if (firstChildNode === "SPAN") return;
            const target = document.getElementsByClassName("menu transition")[0];
            const select = document.getElementsByClassName("selection dropdown")[0];
            if (document.getElementsByClassName("menu visible")[0]) {
                target.classList.remove("visible");
                target.classList.add("hidden");

                select.classList.remove("active");
            } else if(document.getElementsByClassName("menu hidden")[0]) {
                target.classList.remove("hidden");
                target.classList.add("visible");
            }
        },
        async getVendorData() {
            const url = "/api/governance/dashboard/vendor";
            const header = {
                'cmpnId': this.curCmpnId
            };
            try {
                const response = await this.http.post(url, header);
                if (response.data) {
                    this.inUseVendors = response.data;
                } else {
                    console.log("getVendorData: No Data")
                }
            } catch (err) {
                console.error("getVendorData: ", err);
            }
        },
        getFilterData: function () {
            const url = '/api/governance/dashboard/filter';
            const header = {
                'cmpnId': this.curCmpnId
            };
            this.http.post(url, JSON.stringify(header))
                .then(response => {
                    if (response.data.status === 'ok') {
                        let list = response.data.result.list

                        let self = this;
                        if (list != null && list.length > 0) {
                            this.ctgList = _.filter(list, {'filterType': 'ctg'});
                            this.acntList =  _.unionBy(this.$store.state.allAccount.map(ac=>({'key':ac.accId,'val':ac.accAlias,'vendor':ac.vendor})),"key");
                            this.prodList = _.forEach(_.filter(list, {'filterType': 'prod'}), function (o) {
                                o.val = self.$t('PRODUCT.' + o.key);
                            });
                        }
                        this.$nextTick(function () {
                            self.refresh();
                        });

                    }
                });

        },
        refresh() { // data API 호출
            // this.$refs.dashboardRegion.selectFailPassResultList();
            this.curDate = this.getCurrentDate();
            this.selectFailedRuleList();
            this.$refs.dashboardSummary.selectDashboardSummaryRawData();
            this.$refs.dashboardTrend.selectComplianceResultOfCategory();
            this.$refs.dashboardFail.slctCmplList();
        },
        selectFailedRuleList() {
            this.pendingState = true;
            const url = '/api/governance/dashboard/status';
            const header = {
                'cmpnId': this.curCmpnId
            };
            try {
                this.http.post(url, JSON.stringify(header))
                .then(result => {
                    this.pendingState = false;
                    this.failedRulesList = result.data.result;
                });
                // TODO 좋은방안 찾아야함, 최초 선택되는 실패 차트에 넣을 데이터가 0일때 성공으로 넘어가면 차트가 안그려지는 문제 해결해야함
            } catch (err) {
                console.error('selectFailedRuleList: ' + err);
            } finally {
                this.$refs.dashboardSummary.applyFilterRawData();
                this.$refs.dashboardTrend.applyFilterRawData();
                this.$refs.dashboardFail.applyFilterRawData();
                this.$refs.dashboardRegion.applyFilterRawData();
            }
        },
        changeFilterData(type, value) { // client에서 filter
            console.log("type: ", type)
            console.log("value: ", value)
            this.filterData[type] = value;
            this.debouncedSlctFailedRules();

        },
        sendReport() {
            this.Common.viewPopup('popup-send-report-email')
            this.$refs.popSendReport.renderKey++;
        },
        downloadReport() {
            const url = '/api/governance/dashboard/report/make';
            const header = {
                'cmpnId': this.curCmpnId
            };

            this.http.post(url, JSON.stringify(header))
                .then(response => {
                    if (response.data.status === 'ok') {
                        // window.location.assign(response.data.result.path);
                        window.open(response.data.result.path);

                    }
                })
        },
        getCurrentDate: function () {
            return this.Common.convertUtcTimezoneToLocalByLang(new Date(), this.getLocale);
        },
    }

}
</script>

<style scoped>
.dashboard-box-hstack.no-flex {
    display: -webkit-box;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboard.vue